import { MEMBER_TYPE, } from "@erp/shared/components/ui/Dialog/MemberSearchDialog/member.types";
import { requiredInputRule } from "@erp/shared/utils/form/rules";
import { formatDate, formatHour } from "@erp/shared/utils/date/formatted-date";
import { PRODUCT_TYPE } from "@erp/shared/types/product.types";
/**
 * @description 출고 신청 시 선택할 유저 정보
 */
export const outboundMemberInfo = [
    {
        type: MEMBER_TYPE.확인,
        givenName: "",
        id: null,
        userName: "",
    },
    {
        type: MEMBER_TYPE.승인,
        givenName: "",
        id: null,
        userName: "",
    },
];
export const searchEigenStockHeaders = [
    { text: "종류", align: "start", value: "type" },
    { text: "분류", align: "start", value: "classification" },
    { text: "관리코드", align: "start", value: "productCode" },
    { text: "제품명", align: "start", value: "name" },
    { text: "모델명", align: "start", value: "model" },
    { text: "사양", align: "start", value: "spec" },
    { text: "제조사", align: "start", value: "manufacturer" },
    { text: "재고", align: "start", value: "stockNum" },
    { text: "단가", align: "start", value: "unitPrice" },
    { text: "합계", align: "start", value: "totalPrice" },
    { text: "위치", align: "start", value: "spot" },
    { text: "추가", align: "center", value: "actions", sortable: false },
];
export const searchEigenStockInputs = [
    {
        label: "종류",
        key: "type",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
        list: [PRODUCT_TYPE.원부자재, PRODUCT_TYPE.반제품, PRODUCT_TYPE.완제품],
        clearable: true,
    },
    {
        label: "분류",
        key: "classification",
        type: "auto",
        list: [],
        value: "",
        col: "12",
        sm: "4",
        lg: "2",
        clearable: true,
        returnObject: true,
    },
    {
        label: "상태",
        key: "conditions",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "2",
        value: "",
        list: ["G", "B"],
        clearable: true,
    },
    {
        label: "관리코드",
        key: "productCode",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제품명",
        key: "name",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "모델명",
        key: "model",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "사양",
        key: "spec",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
    {
        label: "제조사",
        key: "manufacturer",
        type: "auto",
        col: "12",
        sm: "4",
        lg: "3",
        value: "",
        clearable: true,
    },
];
export const outboundCardInputs = [
    {
        label: "출고(반출)요청일",
        key: "outboundDate",
        column_name: "outboundDate",
        type: "dateSingle",
        col: "12",
        sm: "3",
        lg: "3",
        value: formatDate(),
        rules: [requiredInputRule],
    },
    {
        label: "출고(반출)시간",
        key: "outboundTime",
        column_name: "outboundTime",
        type: "hour",
        col: "12",
        sm: "3",
        lg: "3",
        value: formatHour(),
        rules: [requiredInputRule],
    },
    {
        label: "프로젝트 코드",
        type: "auto",
        key: "projectCode",
        column_name: "projectCode",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        list: ["미선택"],
    },
    {
        label: "출하장소",
        key: "spot",
        column_name: "spot",
        type: "auto",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        list: [],
        rules: [requiredInputRule],
    },
    {
        label: "출고목적",
        key: "purpose",
        column_name: "purpose",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "비고",
        key: "note",
        column_name: "note",
        type: "textarea",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
    },
    {
        label: "시험성적서",
        key: "inspectionReport",
        column_name: "inspectionReport",
        type: "file",
        col: "12",
        sm: "3",
        lg: "3",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        value: null,
    },
    {
        label: "기타",
        key: "etcFiles",
        column_name: "etcFiles",
        type: "file",
        col: "12",
        sm: "3",
        lg: "3",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
        value: null,
    },
];
export const movementCardInputs = [
    {
        label: "출고(반출)요청일",
        key: "outboundDate",
        column_name: "outboundDate",
        type: "dateSingle",
        col: "12",
        sm: "3",
        lg: "3",
        value: formatDate(),
        rules: [requiredInputRule],
    },
    {
        label: "출고(반출)시간",
        key: "outboundTime",
        column_name: "outboundTime",
        type: "hour",
        col: "12",
        sm: "3",
        lg: "3",
        value: formatHour(),
        rules: [requiredInputRule],
    },
    {
        label: "프로젝트 코드",
        type: "auto",
        key: "projectCode",
        column_name: "projectCode",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        list: ["미선택"],
    },
    {
        label: "이동위치",
        type: "auto",
        key: "spot",
        column_name: "spot",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        list: [],
        rules: [requiredInputRule],
    },
    {
        label: "출고목적",
        key: "purpose",
        column_name: "purpose",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
        rules: [requiredInputRule],
    },
    {
        label: "비고",
        key: "note",
        column_name: "note",
        type: "textarea",
        col: "12",
        sm: "3",
        lg: "3",
        value: "",
    },
    {
        label: "시험성적서",
        key: "inspectionReport",
        column_name: "inspectionReport",
        type: "file",
        col: "12",
        sm: "3",
        lg: "3",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        accept: ".pdf",
        value: null,
    },
    {
        label: "기타",
        key: "etcFiles",
        column_name: "etcFiles",
        type: "file",
        col: "12",
        sm: "3",
        lg: "3",
        icon: "",
        appendIcon: "mdi-paperclip",
        smallChips: true,
        multiple: true,
        value: null,
    },
];
export const outboundHeaders = [
    { text: "종류", align: "start", value: "type" },
    { text: "분류", align: "start", value: "classification" },
    { text: "관리코드", align: "start", value: "productCode" },
    { text: "제품명", align: "start", value: "name" },
    { text: "모델명", align: "start", value: "model" },
    { text: "사양", align: "start", value: "spec" },
    { text: "제조사", align: "start", value: "manufacturer" },
    { text: "현위치", align: "start", value: "spot" },
    { text: "재고", align: "start", value: "stockNum" },
    { text: "출고수량", align: "start", value: "num" },
    { text: "단가", align: "start", value: "unitPrice" },
    { text: "제외", align: "center", value: "" },
];
export const emptyRowCheck = {
    validator: (outboundItems) => outboundItems && outboundItems.length > 0,
    errorMessage: "자재를 선택해주세요.",
};
export const outboundChecks = [
    {
        validator: (outboundItem) => !!(outboundItem.num && outboundItem.num > 0),
        errorMessage: "출고 수량 필수 입력",
    },
    {
        validator: (outboundItem) => !!(outboundItem.num <= Number(outboundItem.stockNum)),
        errorMessage: "재고보다 출고 수량이 많습니다.",
    },
];
